// Request identity owns profile data and every effect that follows its fetch.
export const ownsClientDetailAction = (state, action) => Boolean(state?.detailRequestId)
  && state.detailRequestId === action?.meta?.requestId
  && state.detailClientId === (Number(action?.meta?.arg?.id) || null);

export const captureClientDetailSelection = state => ({
  requestId: state?.detailRequestId,
  clientId: state?.detailClientId || Number(state?.isDetailData?.id) || null,
});

export const ownsClientDetailSelection = (state, selection) => Boolean(selection?.clientId && selection?.requestId)
  && (state?.detailClientId || Number(state?.isDetailData?.id) || null) === selection.clientId
  && state?.detailRequestId === selection.requestId;
